/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.




/* Taquiri Google Map Plugin */

(function($){
    var mapsKEY     =   'AIzaSyDAh9fUXIAwWIqb47Ik0SivVKftQJXxQo4';
    var mapsAPI     =   'key='+mapsKEY+"&";

    $.fn.tqMap = function (locations, options) {
        "use strict";

        var $container = $(this),
            $window = $(window);

        if ( $container.length > 0 ) {
            // Google Maps
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://maps.google.com/maps/api/js?"+mapsAPI+"sensor=false&callback=tqMapInit";
            document.body.appendChild(script);
            window.tqMapInit = function() { init(); };
        }

        function init() {

            var settings = $.extend({
                scrollwheel: false,
                zoomControl: false,
                streetViewControl:false,
                scaleControl:true,
                zoom: 12,
                draggable: false,
                disableDefaultUI: true,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                ]
            }, options );

            var map = new google.maps.Map($container[0], settings),
                bounds = new google.maps.LatLngBounds(),
                infowindow = new google.maps.InfoWindow({ content: "loading..." }),
                position, marker, i;

            $.each(locations, function(i, loc) {

                if ( loc.lat && loc.lng ){
                    var route = loc.route || "https://maps.google.com?"+mapsAPI+"saddr=Current+Location&daddr="+loc.lat+","+loc.lng,
                        content = '<div class="infoWindow"><strong>'+loc.name+'</strong><br>'+loc.addr+'<br><a href="'+route+'"><i class="fa fa-road"></i> Routenplaner</a></div>';

                    position = new google.maps.LatLng(loc.lat, loc.lng);

                    marker = new google.maps.Marker({
                        position: position,
                        title: loc.name,
                        icon: loc.icon || undefined,
                        map: map
                    });

                    if ( locations.length > 1 ) {
                        bounds.extend(position);
                        map.fitBounds(bounds);
//                        $window.smartresize(function(){
//                            map.fitBounds(bounds);
//                        });
                    } else {
                        map.setCenter(position);
                        google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                            infowindow.setContent(content);
                            infowindow.open(map, marker);
                        });
//                        $window.smartresize(function(){
//                            map.setCenter(position);
//                        });
                    }

                    google.maps.event.addListener(marker, 'click', function() {
                        infowindow.setContent(content);
                        infowindow.open(map, this);
                    });

                }

            });

        }

    };

    $.fn.tqReferenzenMap = function (locations, options) {
        "use strict";

        var $container = $(this),
            $window = $(window);

        var isMobile = function() {
            try{ document.createEvent("TouchEvent"); return true; }
            catch(e){ return false; }
        };

        if ( $container.length > 0 ) {
            // Google Maps
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://maps.google.com/maps/api/js?"+mapsAPI+"callback=tqMapInit";
            if(isMobile()) {
                script.src += "&v=3.21"; //we need to old version on mobile devices for using the panControl
            }
            document.body.appendChild(script);
            window.tqMapInit = function() { init(); };
        }

        console.log(isMobile());

        function init() {

            var settings = $.extend({
                center: new google.maps.LatLng(51.163375, 10.447683),
                scrollwheel: false,
                zoomControl: true,
                streetViewControl:false,
                scaleControl:true,
                zoom: 12,
                draggable: !isMobile(),
                disableDefaultUI: true,
                panControl: isMobile(),
//				panControl:true,
//				zoomControl:true,
//				mapTypeControl:true,
//				scaleControl:true,
//				streetViewControl:true,
//				overviewMapControl:true,
//				rotateControl:true,
//				mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                ]
            }, options );

            var map = new google.maps.Map($container[0], settings),
                bounds = new google.maps.LatLngBounds(),
                infowindow = new google.maps.InfoWindow({ content: "loading..." }),
                position, marker, i, content, geocoder, link;

            $(document).on('touchstart', '#map div[title*=Nach]', function () {
                $(this).trigger('click');
                return false;
            });

//			geocoder = new google.maps.Geocoder();
//
//			geocoder.geocode( {'address' : "Germany"}, function(results, status) {
//				if (status == google.maps.GeocoderStatus.OK) {
//					map.fitBounds(results[0].geometry.viewport);
//				}
//			});

            $.each(locations, function(i, loc) {

                if ( loc.lat && loc.lng ){
                    content = '<div class="infoWindow"><a title="Zur Webseite" href="'+loc.url+'" target="_blank"><div>';
                    if(loc.logo && loc.logohover) {
                        content += '<img src="'+loc.logo+'" class="img-nor"><img src="'+loc.logohover+'" class="img-hov">';
                    }
                    else if(loc.logo) {
                        content += '<img src="'+loc.logo+'">';
                    }

                    link = loc.url.split('/')[2];

                    content += '</div></a><strong>'+loc.name+'</strong><br><a title="Zur Webseite" href="'+loc.url+'" target="_blank">'+link+'</a></div>';

                    position = new google.maps.LatLng(loc.lat, loc.lng);

                    marker = new google.maps.Marker({
                        position: position,
                        title: loc.name,
                        icon: loc.icon || undefined,
                        map: map,
                        content: content
                    });

                    if ( locations.length > 1 ) {
                        bounds.extend(position);
//						map.fitBounds(bounds);
//						$window.smartresize(function(){
//							map.fitBounds(bounds);
//						});
                    } else {
//						map.setCenter(position);
                        google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                            infowindow.setContent(content);
                            infowindow.open(map, marker);
                        });
//						$window.smartresize(function(){
//							map.setCenter(position);
//						});
                    }

                    google.maps.event.addListener(marker, 'click', function() {
                        infowindow.setContent(this.content);
                        infowindow.open(map, this);
                    });

                }

            });

        }

    };

})(jQuery);


/**
 * Eigene Scripte
 */
jQuery(document).ready(function($){
    // für die Map
    var locations_rm = [
        {
            name: 'PhysioPraxis Stefanie Linicus',
            addr: 'Valterweg 27, 65817 Eppstein',
            lat: 50.139496,
            lng: 8.344968,
            zoom: 12,
            icon: location.protocol + "//" + location.host + "/wp-content/themes/linicus/dist/images/map-marker.png"
        }
    ];

    $("#map-linicus").tqMap(locations_rm);
});